import React, { useState, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { AppBar, Toolbar, Button, Typography, IconButton, Menu, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: 'rgba(0, 0, 0, 0.5)', 
  color: 'black',
  boxShadow: 'none',
  backdropFilter: 'blur(10px)',
}));

const StyledToolbar = styled(Toolbar)({
  justifyContent: 'space-between',
});

const Title = styled(Typography)({
  flexGrow: 1,
  fontWeight: 600, 
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', 
  fontSize: '1.3rem', 
  textTransform: 'uppercase',
  letterSpacing: '0.15rem', 
});

const NavButtons = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

const MenuButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

const NavigationBar = () => {
  // const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleScroll = useCallback((sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setAnchorEl(null); // Close the menu upon selection
  }, []);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <StyledAppBar position="static">
      <StyledToolbar>
        <Title>Manish Singh.</Title>
        <NavButtons>
          {/* <Button color="inherit" onClick={() => navigate('/blogs')}>Blogs</Button> */}
          <Button color="inherit" onClick={() => handleScroll('experienceSection')}>Work Experiences</Button>
          <Button color="inherit" onClick={() => handleScroll('skillsSection')}>Skills</Button>
          <Button color="inherit" onClick={() => handleScroll('educationSection')}>Education</Button>
          <Button color="inherit" onClick={() => handleScroll('connectSection')}>Connect</Button>
        </NavButtons>
        <MenuButton edge="end" color="inherit" aria-label="menu" onClick={handleMenu}>
          <MenuIcon />
        </MenuButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          {/* <MenuItem onClick={() => navigate('/blogs')}>Blogs</MenuItem> */}
          <MenuItem onClick={() => handleScroll('experienceSection')}>Work Experiences</MenuItem>
          <MenuItem onClick={() => handleScroll('skillsSection')}>Skills</MenuItem>
          <MenuItem onClick={() => handleScroll('educationSection')}>Education</MenuItem>
          <MenuItem onClick={() => handleScroll('connectSection')}>Connect</MenuItem>
        </Menu>
      </StyledToolbar>
    </StyledAppBar>
  );
};

export default NavigationBar;